import React from "react";

export const DedicationScreen = ({ onContinue }) => (
  <div className="dedication" data-testid="dedication-overlay">
    <div className="ded-scroll">
      <div className="ded-title">סוחר הים</div>
      <div className="ded-subtitle">מקדש זיכרון למשחק אהוב</div>
      <div className="ded-divider">· · ·</div>
      <p className="ded-p">משחק זה נולד מתוך אהבה עמוקה לאחד ממשחקי המחשב הישראליים הבלתי נשכחים.</p>
      <p className="ded-p">
        תודה לאחותי, <span className="ded-name">שני</span>, שמזכירה לי שוב ושוב שיום אחד אשב על הפרויקט הזה
        ואחזיר אותו לחיים.
      </p>
      <p className="ded-p">
        תודה ל־<span className="ded-name">אביץ</span>, האגדי, שפתח בפניי בווליום גבוה את עולם ה־
        <span className="ded-en">Vibe Coding</span> והראה לי שאפשר לחלום בגדול.
      </p>
      <p className="ded-p">
        ותודה ל־<span className="ded-name">אנתרופיק</span>, על ה<span className="ded-en">"מיתוס"</span> שהספיק להיעלם.
      </p>
      <p className="ded-p">
        ותודה ענקית, מיוחדת ואינסופית ל־<span className="ded-name">אשד שחם</span>, שפירק במשך חמש שנים את
        קובץ ה־<span className="ded-en">K.COM</span>, שורה אחר שורה, והפך אותו לאלפי שורות פסקל קריאות.
        עבודה נדירה של התמדה, מקצוענות ואהבה, שהניחה את היסודות לתוצר המטורף שאתם רואים כאן.
      </p>
      <p className="ded-p">לכל מי ששיחק, זכר, התגעגע, חקר, תיעד ושמר את ההיסטוריה של המשחק הזה בחיים.</p>
      <p className="ded-p ded-hint">
        💡 תציצו ב<span className="ded-name">הגדרות</span> המרעננות של האפליקציה — תמצאו שם דברים מפתיעים.
      </p>
      <div className="ded-end">המסע מתחיל מחדש.</div>
      <div className="ded-copy">© 2026</div>
      <div className="ded-disclaimer" data-testid="dedication-disclaimer">
        <div className="ded-disclaimer-title">הערה</div>
        <div className="ded-disclaimer-text">
          המשחק הוא פרויקט חובבים ואינו מסחרי. לכל עניין ניתן לפנות ל־
          <a
            href="mailto:yosale2011@gmail.com"
            className="ded-disclaimer-mail"
            data-testid="dedication-disclaimer-email"
          >
            yosale2011@gmail.com
          </a>
        </div>
      </div>
      <button className="rbtn primary wide ded-btn" data-testid="dedication-continue-btn" onClick={onContinue}>
        ◄ הפלג
      </button>
    </div>
    <div className="scanlines" />
  </div>
);
